module.exports = __webpack_public_path__ + "img/roundWarning.abe8e79f.svg";